export default __webpack_public_path__ + "static/TheUSremotenorthernoutpost-6d78f3df44ff1c8cb242e01fac6249c3.jpg";